<template>
    <div>
        <app-layout>
            <template v-slot:header>
                <Header :title="$t('pcgc')" :is-filter="false" />
            </template>
            <template v-slot:header-mobile>
                <HeaderMobile :title="$t('pcgc')" :is-filter="false" />
            </template>
            <b-row>
                <b-col sm="4">
                    <b-alert show :variant="step == 1 ? 'primary' : 'dark'">
                        <b-row>
                            <b-col sm="12" md="3" style="font-weight: bold; font-size: 65px;">1</b-col>
                            <b-col sm="12" md="9" class="mt-3" style="font-size: 22px;"><span v-html="$t('pcgc_step_1_html')"/></b-col>
                        </b-row>
                    </b-alert>
                </b-col>
                <b-col sm="4">
                    <b-alert show :variant="step == 2 ? 'primary' : 'dark'">
                        <b-row>
                            <b-col sm="12" md="3" style="font-weight: bold; font-size: 65px;">2</b-col>
                            <b-col sm="12" md="9" class="mt-3" style="font-size: 22px;"><span v-html="$t('pcgc_step_2_html')"/></b-col>
                        </b-row>
                    </b-alert>
                </b-col>
                <b-col sm="4">
                    <b-alert show :variant="step == 3 ? 'primary' : 'dark'">
                        <b-row>
                            <b-col sm="12" md="3" style="font-weight: bold; font-size: 65px;">3</b-col>
                            <b-col sm="12" md="9" class="mt-3" style="font-size: 22px;"><span v-html="$t('pcgc_step_3_html')"/></b-col>
                        </b-row>
                    </b-alert>
                </b-col>
            </b-row>
            <b-row v-if="step == 1">
                <b-col sm="12">
                    <div class="border rounded p-4 bg-white">
                        <b-row>
                            <b-col sm="12">
                                Merkezimizdeki tüm hizmetler Türk Psikologlar Derneği Etik Yönetmeliği ilke ve yöntemleri
                                çerçevesinde verilmektedir. Bu ilkeler şunlardır:
                                Gizlilik: Bizimle paylaştığınız bilgiler gizli tutulur; izniniz olmadan ailenize, öğretim elemanlarına
                                ya da diğer kişi ve kurumlara aktarılmaz. Sizin veya bir başkasının yaşamını tehlikeye atacak bir
                                durum söz konusu olduğunda bu ilkeler PDRM uzmanları tarafından tekrar gözden geçirilebilir.
                                Koşulsuz kabul ve saygı: PDRM bireysel farklılıklara her zaman saygı duyar. Sahip olunan inanç,
                                değer ve özellikler ne olursa olsun ayrımcılık yapılmaz.
                                Yetkinlik: Danışman ekibimiz alanlarında uzmanlık derecelerini almış, bilimsellik temelinde
                                hareket eden, kendilerini geliştirmeyi sürdüren, mesleki gözetim ve konsültasyon alan bireylerden
                                oluşur. <br>
                                BİLGİNİZE <br>
                                1. Bireysel görüşmeler yaklaşık 45 dakika sürmektedir. <br>
                                2. İlk görüşme bir değerlendirme görüşmesidir. Bu görüşmenin ardından, başvuran öğrenciyle
                                kısa süreli ve sınırlı sayıda olmak üzere bir görüşme süreci başlatılabilir veya eğer süresi
                                sınırlı olmayan kapsamlı bir çalışmaya ihtiyaç olduğu veya merkez dışı kaynaklardan daha
                                iyi yararlanılabileceği düşünülürse kurum içine veya kurum dışına yönlendirmeler
                                yapılabilir. <br>
                                3. Görüşmeler genelde haftada bir yapılmaktadır. Görüşmelere düzenli devam etmeniz
                                aldığınız hizmetin size daha yararlı olmasını sağlar. <br>
                                4. Görüşmeler yüz yüze ve online olarak devam etmektedir. <br>
                                5. Randevunuza kararlaştırılan günde ve tam saatinde gelmeniz önemlidir. Randevuyu üst
                                üste iki kere iptal etme durumunuzda, devam eden danışmanlık süreciniz otomatik
                                olarak sonlanmakta ve başvurunuz PDRM bekleme listesine alınmaktadır. <br>
                                6. Görüşmeleri sonlandırmaya karar verirseniz danışmanınızı lütfen haberdar ediniz. <br>
                                7. İşleyiş ilke ve yöntemlerimiz hakkındaki sorularınızı danışmanınıza sorabilirsiniz. <br>
                                8. Görüşme süresince konuşulan her türlü detay ve bilgi tarafımızca gizli tutulacaktır. Bununla
                                birlikte, ailenizin, üniversite idari veya akademik kadrosundan bir görevlinin sizin bilginiz
                                dışında birimimizle temasa geçmesi halinde, PDRM’ye başvurup başvurmadığınız / devam
                                edip etmediğiniz bilgisininu kişilere aktarılmasını onaylayıp onaylamadığınızı aşağıda
                                belirtiniz. <br>
                            </b-col>
                            <b-col sm="4" class="mt-4">
                                <ValidationObserver ref="approveForm">
                                    <b-row>
                                        <b-col sm="12">
                                            <ValidationProvider name="with_family" rules="required" v-slot="{ errors }">
                                                <b-form-group :label="$t('pcgc_with_family')">
                                                    <multi-selectbox v-model="approveData.share_with_family"
                                                                     :multiple="false"
                                                                     :options="approveOptions"
                                                                     :validate-error="errors[0]"/>
                                                </b-form-group>
                                            </ValidationProvider>
                                        </b-col>
                                        <b-col sm="12">
                                            <ValidationProvider name="with_university" rules="required" v-slot="{ errors }">
                                                <b-form-group :label="$t('pcgc_with_university')">
                                                    <multi-selectbox v-model="approveData.share_with_university"
                                                                     :multiple="false"
                                                                     :options="approveOptions"
                                                                     :validate-error="errors[0]"/>
                                                </b-form-group>
                                            </ValidationProvider>
                                        </b-col>
                                        <b-col sm="12">
                                            <ValidationProvider name="with_one_of_academics" rules="required" v-slot="{ errors }">
                                                <b-form-group :label="$t('pcgc_with_one_of_academics')">
                                                    <multi-selectbox v-model="approveData.share_with_instructor"
                                                                     :multiple="false"
                                                                     :options="approveOptions"
                                                                     :validate-error="errors[0]"/>
                                                </b-form-group>
                                            </ValidationProvider>
                                        </b-col>
                                    </b-row>
                                </ValidationObserver>
                            </b-col>
                            <b-col sm="12" class="mt-4">
                                <b-button variant="primary" @click="saveApprove">{{ $t('pcgc_approve_btn') }}</b-button>
                            </b-col>
                        </b-row>
                    </div>
                </b-col>
            </b-row>
            <b-row v-if="step == 2">
                <b-col sm="12">
                    <div class="border rounded p-4 bg-white">
                        <b-row>
                            <b-col sm="12" md="8">
                                <ValidationObserver ref="applicationForm">
                                    <b-row>
                                        <b-col sm="12" md="12">
                                            <b-form-group :label="$t('date')">
                                                {{ currentDateForm }}
                                            </b-form-group>
                                        </b-col>
                                        <b-col sm="12" md="4">
                                            <b-form-group :label="$t('student_number')">
                                                {{ studentData.student.student_number }}
                                            </b-form-group>
                                        </b-col>
                                        <b-col sm="12" md="4">
                                            <b-form-group :label="$t('name')">
                                                {{ studentData.name }}
                                            </b-form-group>
                                        </b-col>
                                        <b-col sm="12" md="4">
                                            <b-form-group :label="$t('surname')">
                                                {{ studentData.surname }}
                                            </b-form-group>
                                        </b-col>
                                        <b-col sm="12" md="4">
                                            <b-form-group :label="$t('birthdate')">
                                                {{ studentData.person.birthdate }}
                                            </b-form-group>
                                        </b-col>
                                        <b-col sm="12" md="4">
                                            <b-form-group :label="$t('birthplace')">
                                                {{ studentData.person.birthplace }}
                                            </b-form-group>
                                        </b-col>
                                        <b-col sm="12" md="4">
                                            <b-form-group :label="$t('gender')">
                                                {{ studentData.person.gender }}
                                            </b-form-group>
                                        </b-col>
                                        <b-col sm="12" md="4">
                                            <b-form-group :label="$t('faculty')">
                                                {{ getLocaleText(studentData.active_student_program, 'faculty_name') }}
                                            </b-form-group>
                                        </b-col>
                                        <b-col sm="12" md="4">
                                            <b-form-group :label="$t('department')">
                                                {{ getLocaleText(studentData.active_student_program, 'program_name') }}
                                            </b-form-group>
                                        </b-col>
                                        <b-col sm="12" md="4">
                                            <b-form-group :label="$t('class')">
                                                {{ getLocaleText(studentData.active_student_program, 'class_name') }}
                                            </b-form-group>
                                        </b-col>
                                        <b-col sm="12" md="12" class="font-weight-bold font-size-16 mt-2 mb-2">{{ $t('contact_information') }}</b-col>
                                        <b-col sm="12" md="4">
                                            <b-form-group :label="$t('city')">
                                                {{ studentData.person.contact_city_id }}
                                            </b-form-group>
                                        </b-col>
                                        <b-col sm="12" md="4">
                                            <b-form-group :label="$t('district')">
                                                {{ studentData.person.contact_district_id }}
                                            </b-form-group>
                                        </b-col>
                                        <b-col sm="12" md="4">
                                            <b-form-group :label="$t('address')">
                                                {{ studentData.person.contact_address }}
                                            </b-form-group>
                                        </b-col>
                                        <b-col sm="12" md="4">
                                            <b-form-group :label="$t('telephone')">
                                                {{ studentData.person.mobile_tel }}
                                            </b-form-group>
                                        </b-col>
                                        <b-col sm="12" md="8">
                                            <b-form-group :label="$t('email')">
                                                {{ studentData.email }}
                                            </b-form-group>
                                        </b-col>
                                        <b-col sm="12" md="4">
                                            <ValidationProvider name="living_place" rules="required" v-slot="{ errors }">
                                                <b-form-group :label="$t('pcgc_place_of_residence')">
                                                    <multi-selectbox v-model="applicationForm.living_place"
                                                                     :multiple="false"
                                                                     :options="placeOfResidenceOptions"
                                                                     :validate-error="errors[0]"/>
                                                </b-form-group>
                                            </ValidationProvider>
                                            <ValidationProvider v-if="applicationForm.living_place == 'dormitory'" name="living_place_detail" rules="required" v-slot="{ valid, errors }">
                                                <b-form-group :label="$t('pcgc_dormitory_name')">
                                                    <b-form-input
                                                        v-model="applicationForm.living_place_detail"
                                                        :placeholder="$t('please_specify')"
                                                        :state="errors[0] ? false : (valid ? true : null)" />
                                                    <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                                                </b-form-group>
                                            </ValidationProvider>
                                            <ValidationProvider v-if="applicationForm.living_place == 'other'" name="living_place_detail" rules="required" v-slot="{ valid, errors }">
                                                <b-form-group :label="$t('other')">
                                                    <b-form-input
                                                        v-model="applicationForm.living_place_detail"
                                                        :placeholder="$t('please_specify')"
                                                        :state="errors[0] ? false : (valid ? true : null)" />
                                                    <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                                                </b-form-group>
                                            </ValidationProvider>
                                        </b-col>
                                        <b-col sm="12" md="12" class="mt-2 mb-2">{{ $t('pcgc_emergency_person') }}</b-col>
                                        <b-col sm="12" md="4">
                                            <ValidationProvider  name="emergency_contact_name" rules="required" v-slot="{ valid, errors }">
                                                <b-form-group :label="$t('name_surname')">
                                                    <b-form-input
                                                        v-model="applicationForm.emergency_contact_name"
                                                        :state="errors[0] ? false : (valid ? true : null)" />
                                                    <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                                                </b-form-group>
                                            </ValidationProvider>
                                        </b-col>
                                        <b-col sm="12" md="4">
                                            <ValidationProvider  name="emergency_contact_phone" rules="required" v-slot="{ valid, errors }">
                                                <b-form-group :label="$t('telephone')">
                                                    <b-form-input
                                                        v-model="applicationForm.emergency_contact_phone"
                                                        v-mask="'5## ### ## ##'"
                                                        placeholder="5__ ___ __ __"
                                                        :state="errors[0] ? false : (valid ? true : null)" />
                                                    <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                                                </b-form-group>
                                            </ValidationProvider>
                                        </b-col>
                                        <b-col sm="12" md="4">
                                            <ValidationProvider  name="emergency_contact_relationship" rules="required" v-slot="{ valid, errors }">
                                                <b-form-group :label="$t('degree_of_proximity')">
                                                    <b-form-input
                                                        v-model="applicationForm.emergency_contact_relationship"
                                                        :state="errors[0] ? false : (valid ? true : null)" />
                                                    <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                                                </b-form-group>
                                            </ValidationProvider>
                                        </b-col>
                                        <b-col sm="12" md="8" class="mt-2 mb-2">
                                            <b-row>
                                                <b-col sm="12" md="6">
                                                    <b-row>
                                                        <b-col sm="12" md="12" class="font-weight-bold font-size-16">{{ $t('pcgc_your_mother') }}</b-col>
                                                        <b-col sm="12" md="12">
                                                            <ValidationProvider name="mother_is_alive" rules="required" v-slot="{ errors }">
                                                                <b-form-group :label="$t('pcgc_is_alive')">
                                                                    <multi-selectbox v-model="applicationForm.mother_is_alive"
                                                                                     :multiple="false"
                                                                                     :options="yesNoOptions"
                                                                                     :validate-error="errors[0]"/>
                                                                </b-form-group>
                                                            </ValidationProvider>
                                                            <ValidationProvider  name="mother_age" rules="required" v-slot="{ valid, errors }">
                                                                <b-form-group :label="$t('pcgc_age')">
                                                                    <b-form-input
                                                                        v-model="applicationForm.mother_age"
                                                                        :state="errors[0] ? false : (valid ? true : null)" />
                                                                    <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                                                                </b-form-group>
                                                            </ValidationProvider>
                                                            <ValidationProvider  name="mother_education" rules="required" v-slot="{ valid, errors }">
                                                                <b-form-group :label="$t('pcgc_education_level')">
                                                                    <b-form-input
                                                                        v-model="applicationForm.mother_education"
                                                                        :state="errors[0] ? false : (valid ? true : null)" />
                                                                    <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                                                                </b-form-group>
                                                            </ValidationProvider>
                                                            <ValidationProvider  name="mother_profession" rules="required" v-slot="{ valid, errors }">
                                                                <b-form-group :label="$t('pcgc_job')">
                                                                    <b-form-input
                                                                        v-model="applicationForm.mother_profession"
                                                                        :state="errors[0] ? false : (valid ? true : null)" />
                                                                    <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                                                                </b-form-group>
                                                            </ValidationProvider>
                                                            <ValidationProvider  name="mother_phone" rules="required" v-slot="{ valid, errors }">
                                                                <b-form-group :label="$t('telephone')">
                                                                    <b-form-input
                                                                        v-model="applicationForm.mother_phone"
                                                                        v-mask="'5## ### ## ##'"
                                                                        placeholder="5__ ___ __ __"
                                                                        :state="errors[0] ? false : (valid ? true : null)" />
                                                                    <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                                                                </b-form-group>
                                                            </ValidationProvider>
                                                        </b-col>
                                                    </b-row>
                                                </b-col>
                                                <b-col sm="12" md="6">
                                                    <b-row>
                                                        <b-col sm="12" md="12" class="font-weight-bold font-size-16">{{ $t('pcgc_your_father') }}</b-col>
                                                        <b-col sm="12" md="12">
                                                            <ValidationProvider name="father_is_alive" rules="required" v-slot="{ errors }">
                                                                <b-form-group :label="$t('pcgc_is_alive')">
                                                                    <multi-selectbox v-model="applicationForm.father_is_alive"
                                                                                     :multiple="false"
                                                                                     :options="yesNoOptions"
                                                                                     :validate-error="errors[0]"/>
                                                                </b-form-group>
                                                            </ValidationProvider>
                                                            <ValidationProvider  name="father_age" rules="required" v-slot="{ valid, errors }">
                                                                <b-form-group :label="$t('pcgc_age')">
                                                                    <b-form-input
                                                                        v-model="applicationForm.father_age"
                                                                        :state="errors[0] ? false : (valid ? true : null)" />
                                                                    <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                                                                </b-form-group>
                                                            </ValidationProvider>
                                                            <ValidationProvider  name="father_education" rules="required" v-slot="{ valid, errors }">
                                                                <b-form-group :label="$t('pcgc_education_level')">
                                                                    <b-form-input
                                                                        v-model="applicationForm.father_education"
                                                                        :state="errors[0] ? false : (valid ? true : null)" />
                                                                    <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                                                                </b-form-group>
                                                            </ValidationProvider>
                                                            <ValidationProvider  name="father_profession" rules="required" v-slot="{ valid, errors }">
                                                                <b-form-group :label="$t('pcgc_job')">
                                                                    <b-form-input
                                                                        v-model="applicationForm.father_profession"
                                                                        :state="errors[0] ? false : (valid ? true : null)" />
                                                                    <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                                                                </b-form-group>
                                                            </ValidationProvider>
                                                            <ValidationProvider  name="father_phone" rules="required" v-slot="{ valid, errors }">
                                                                <b-form-group :label="$t('telephone')">
                                                                    <b-form-input
                                                                        v-model="applicationForm.father_phone"
                                                                        v-mask="'5## ### ## ##'"
                                                                        placeholder="5__ ___ __ __"
                                                                        :state="errors[0] ? false : (valid ? true : null)" />
                                                                    <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                                                                </b-form-group>
                                                            </ValidationProvider>
                                                        </b-col>
                                                    </b-row>
                                                </b-col>
                                            </b-row>
                                        </b-col>
                                        <b-col sm="12" md="12"></b-col>
                                        <b-col sm="12" md="4">
                                            <ValidationProvider name="parents_relationship_status" rules="required" v-slot="{ errors }">
                                                <b-form-group :label="$t('pcgc_mother_and_father')">
                                                    <multi-selectbox v-model="applicationForm.parents_relationship_status"
                                                                     :multiple="false"
                                                                     :options="parentsMaritialOptions"
                                                                     :validate-error="errors[0]"/>
                                                </b-form-group>
                                            </ValidationProvider>
                                            <ValidationProvider v-if="applicationForm.parents_relationship_status == 'other'" name="parents_relationship_status_detail" rules="required" v-slot="{ valid, errors }">
                                                <b-form-group :label="$t('other')">
                                                    <b-form-input
                                                        v-model="applicationForm.parents_relationship_status_detail"
                                                        :placeholder="$t('please_specify')"
                                                        :state="errors[0] ? false : (valid ? true : null)" />
                                                    <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                                                </b-form-group>
                                            </ValidationProvider>
                                        </b-col>
                                        <b-col sm="12" md="12" class="font-weight-bold font-size-16 mt-2 mb-2">{{ $t('pcgc_siblings') }}</b-col>
                                        <b-col sm="12" md="4">
                                            <ValidationProvider name="has_siblings" rules="required" v-slot="{ errors }">
                                                <b-form-group :label="$t('pcgc_have')">
                                                    <multi-selectbox v-model="applicationForm.has_siblings"
                                                                     :multiple="false"
                                                                     :options="yesNoOptions"
                                                                     :validate-error="errors[0]"/>
                                                </b-form-group>
                                            </ValidationProvider>
                                        </b-col>
                                        <b-col sm="12" md="4">
                                            <ValidationProvider name="female_sibling_count" :rules="applicationForm.has_siblings == 'E' ? 'required' : ''" v-slot="{ valid, errors }">
                                                <b-form-group :label="$t('pcgc_how_many_girl')">
                                                    <b-form-input
                                                        v-model="applicationForm.female_sibling_count"
                                                        :state="errors[0] ? false : (valid ? true : null)" />
                                                    <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                                                </b-form-group>
                                            </ValidationProvider>
                                            <ValidationProvider name="female_sibling_ages" :rules="applicationForm.female_sibling_count ? 'required' : ''" v-slot="{ valid, errors }">
                                                <b-form-group :label="$t('pcgc_ages')">
                                                    <b-form-input
                                                        v-model="applicationForm.female_sibling_ages"
                                                        :state="errors[0] ? false : (valid ? true : null)" />
                                                    <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                                                </b-form-group>
                                            </ValidationProvider>
                                        </b-col>
                                        <b-col sm="12" md="4">
                                            <ValidationProvider name="male_sibling_count" :rules="applicationForm.has_siblings == 'E' ? 'required' : ''" v-slot="{ valid, errors }">
                                                <b-form-group :label="$t('pcgc_how_many_boy')">
                                                    <b-form-input
                                                        v-model="applicationForm.male_sibling_count"
                                                        :state="errors[0] ? false : (valid ? true : null)" />
                                                    <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                                                </b-form-group>
                                            </ValidationProvider>
                                            <ValidationProvider name="male_sibling_ages" :rules="applicationForm.male_sibling_count ? 'required' : ''" v-slot="{ valid, errors }">
                                                <b-form-group :label="$t('pcgc_ages')">
                                                    <b-form-input
                                                        v-model="applicationForm.male_sibling_ages"
                                                        :state="errors[0] ? false : (valid ? true : null)" />
                                                    <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                                                </b-form-group>
                                            </ValidationProvider>
                                        </b-col>
                                        <b-col sm="12" md="12" class="font-weight-bold font-size-16 mt-2 mb-2">{{ $t('pcgc_application_reason').toUpper() }}</b-col>
                                        <b-col sm="12" md="12">
                                            <ValidationProvider name="application_reason" rules="required" v-slot="{ errors }">
                                                <b-form-group label="">
                                                    <b-form-textarea v-model="applicationForm.application_reason"
                                                                     :placeholder="$t('pcgc_reason_info')"
                                                                     rows="6"
                                                                     :state="errors[0] ? false : null" />
                                                    <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]" />
                                                </b-form-group>
                                            </ValidationProvider>
                                        </b-col>
                                        <b-col sm="12" md="12" class="font-weight-bold font-size-16 mt-2 mb-2">{{ $t('pcgc_before').toUpper() }}</b-col>
                                        <b-col sm="12" md="6">
                                            <ValidationProvider name="has_previous_pdrm_interview" rules="required" v-slot="{ errors }">
                                                <b-form-group :label="$t('pcgc_before_meet_pcgc')">
                                                    <multi-selectbox v-model="applicationForm.has_previous_pdrm_interview"
                                                                     :multiple="false"
                                                                     :options="yesNoOptions"
                                                                     :validate-error="errors[0]"/>
                                                </b-form-group>
                                            </ValidationProvider>
                                            <ValidationProvider v-if="applicationForm.has_previous_pdrm_interview == 'E'" name="previous_pdrm_interview_dates" rules="required" v-slot="{ errors }">
                                                <b-form-group :label="$t('pcgc_which_dates')">
                                                    <b-form-textarea v-model="applicationForm.previous_pdrm_interview_dates"
                                                                     rows="3"
                                                                     :state="errors[0] ? false : null" />
                                                    <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]" />
                                                </b-form-group>
                                            </ValidationProvider>
                                            <ValidationProvider v-if="applicationForm.has_previous_pdrm_interview == 'E'" name="previous_pdrm_interview_specialists" rules="required" v-slot="{ errors }">
                                                <b-form-group :label="$t('pcgc_who_experts')">
                                                    <b-form-textarea v-model="applicationForm.previous_pdrm_interview_specialists"
                                                                     rows="3"
                                                                     :state="errors[0] ? false : null" />
                                                    <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]" />
                                                </b-form-group>
                                            </ValidationProvider>
                                        </b-col>
                                        <b-col sm="12" md="12">
                                            <ValidationProvider name="has_external_psychological_support" rules="required" v-slot="{ errors }">
                                                <b-form-group :label="$t('pcgc_external_psychologist')">
                                                    <multi-selectbox v-model="applicationForm.has_external_psychological_support"
                                                                     :multiple="false"
                                                                     :options="yesNoOptions"
                                                                     :validate-error="errors[0]"/>
                                                </b-form-group>
                                            </ValidationProvider>
                                        </b-col>
                                        <b-col sm="12" md="6">
                                            <ValidationProvider name="has_suicide_attempt" rules="required" v-slot="{ errors }">
                                                <b-form-group :label="$t('pcgc_suicide_attempt')">
                                                    <multi-selectbox v-model="applicationForm.has_suicide_attempt"
                                                                     :multiple="false"
                                                                     :options="yesNoOptions"
                                                                     :validate-error="errors[0]"/>
                                                </b-form-group>
                                            </ValidationProvider>
                                        </b-col>
                                        <b-col sm="12" md="12" class="font-weight-bold font-size-16 mt-2 mb-2">{{ $t('pcgc_right_now').toUpper() }}</b-col>
                                        <b-col sm="12" md="6">
                                            <ValidationProvider name="has_self_harm_or_suicidal_thoughts" rules="required" v-slot="{ errors }">
                                                <b-form-group :label="$t('pcgc_suicide_attempt_opinion_now')">
                                                    <multi-selectbox v-model="applicationForm.has_self_harm_or_suicidal_thoughts"
                                                                     :multiple="false"
                                                                     :options="yesNoOptions"
                                                                     :validate-error="errors[0]"/>
                                                </b-form-group>
                                            </ValidationProvider>
                                        </b-col>
                                        <b-col sm="12" md="6">
                                            <ValidationProvider name="has_psychological_treatment" rules="required" v-slot="{ errors }">
                                                <b-form-group :label="$t('pcgc_psychology_treat')">
                                                    <multi-selectbox v-model="applicationForm.has_psychological_treatment"
                                                                     :multiple="false"
                                                                     :options="yesNoOptions"
                                                                     :validate-error="errors[0]"/>
                                                </b-form-group>
                                            </ValidationProvider>
                                            <ValidationProvider v-if="applicationForm.has_psychological_treatment == 'E'" name="treatment_specialist_name" rules="required" v-slot="{ valid, errors }">
                                                <b-form-group :label="$t('pcgc_psychology_treat_expert_name')">
                                                    <b-form-input
                                                        v-model="applicationForm.treatment_specialist_name"
                                                        :state="errors[0] ? false : (valid ? true : null)" />
                                                    <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                                                </b-form-group>
                                            </ValidationProvider>
                                            <ValidationProvider v-if="applicationForm.has_psychological_treatment == 'E'" name="treatment_specialist_phone" rules="required" v-slot="{ valid, errors }">
                                                <b-form-group :label="$t('pcgc_psychology_treat_expert_phone')">
                                                    <b-form-input
                                                        v-model="applicationForm.treatment_specialist_phone"
                                                        v-mask="'5## ### ## ##'"
                                                        placeholder="5__ ___ __ __"
                                                        :state="errors[0] ? false : (valid ? true : null)" />
                                                    <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                                                </b-form-group>
                                            </ValidationProvider>
                                        </b-col>
                                        <b-col sm="12" md="6">
                                            <ValidationProvider name="has_diagnosed_physical_condition" rules="required" v-slot="{ errors }">
                                                <b-form-group :label="$t('pcgc_physical_problem_now')">
                                                    <multi-selectbox v-model="applicationForm.has_diagnosed_physical_condition"
                                                                     :multiple="false"
                                                                     :options="yesNoOptions"
                                                                     :validate-error="errors[0]"/>
                                                </b-form-group>
                                            </ValidationProvider>
                                            <ValidationProvider v-if="applicationForm.has_diagnosed_physical_condition == 'E'" name="diagnosed_physical_condition_detail" rules="required" v-slot="{ errors }">
                                                <b-form-group :label="$t('pcgc_please_explanation')">
                                                    <b-form-textarea v-model="applicationForm.diagnosed_physical_condition_detail"
                                                                     rows="3"
                                                                     :state="errors[0] ? false : null" />
                                                    <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]" />
                                                </b-form-group>
                                            </ValidationProvider>
                                        </b-col>
                                        <b-col sm="12" md="6">
                                            <ValidationProvider name="has_medication" rules="required" v-slot="{ errors }">
                                                <b-form-group :label="$t('pcgc_have_use_medicine')">
                                                    <multi-selectbox v-model="applicationForm.has_medication"
                                                                     :multiple="false"
                                                                     :options="yesNoOptions"
                                                                     :validate-error="errors[0]"/>
                                                </b-form-group>
                                            </ValidationProvider>
                                            <ValidationProvider v-if="applicationForm.has_medication == 'E'" name="medication_names" rules="required" v-slot="{ errors }">
                                                <b-form-group :label="$t('pcgc_which_medicines')">
                                                    <b-form-textarea v-model="applicationForm.medication_names"
                                                                     rows="3"
                                                                     :state="errors[0] ? false : null" />
                                                    <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]" />
                                                </b-form-group>
                                            </ValidationProvider>
                                            <ValidationProvider v-if="applicationForm.has_medication == 'E'" name="medication_usage_reason_duration" rules="required" v-slot="{ errors }">
                                                <b-form-group :label="$t('pcgc_why_how_log_use_medicines')">
                                                    <b-form-textarea v-model="applicationForm.medication_usage_reason_duration"
                                                                     rows="3"
                                                                     :state="errors[0] ? false : null" />
                                                    <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]" />
                                                </b-form-group>
                                            </ValidationProvider>
                                            <ValidationProvider v-if="applicationForm.has_medication == 'E'" name="medication_start_method" rules="required" v-slot="{ errors }">
                                                <b-form-group :label="$t('pcgc_how_start_use_medicine')">
                                                    <multi-selectbox v-model="applicationForm.medication_start_method"
                                                                     :multiple="false"
                                                                     :options="useMedicineOptions"
                                                                     :validate-error="errors[0]"/>
                                                </b-form-group>
                                            </ValidationProvider>
                                            <ValidationProvider v-if="applicationForm.medication_start_method == 'other' && applicationForm.has_medication == 'E'" name="medication_start_method_detail" rules="required" v-slot="{ valid, errors }">
                                                <b-form-group :label="$t('please_specify')">
                                                    <b-form-input
                                                        v-model="applicationForm.medication_start_method_detail"
                                                        :state="errors[0] ? false : (valid ? true : null)" />
                                                    <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                                                </b-form-group>
                                            </ValidationProvider>
                                        </b-col>
                                        <b-col sm="12" md="12" class="mt-4">
                                            <b-button variant="primary" @click="saveForm">{{ $t('pcgc_save_info') }}</b-button>
                                        </b-col>
                                    </b-row>
                                </ValidationObserver>
                            </b-col>
                        </b-row>
                    </div>
                </b-col>
            </b-row>
            <b-row v-if="step == 3">
                <b-col sm="12">
                    <ValidationObserver ref="appointmentForm">
                        <div class="border rounded p-4 bg-white">
                            <b-row>
                                <b-col sm="12" md="8">
                                    <ValidationProvider name="psychologist" rules="" v-slot="{ errors }">
                                        <b-form-group :label="$t('psychologist')">
                                            <multi-selectbox v-model="appointmentForm.psychologist"
                                                             :multiple="false"
                                                             :options="psychologistOptions"
                                                             :validate-error="errors[0]"/>
                                        </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                                <b-col sm="12" md="12">
                                    <vue-cal :selected-date="startDate"
                                             :time-cell-height="65"
                                             :time-step="60"
                                             :disable-views="['years', 'year', 'month', 'days', 'day']"
                                             :events="timetables"
                                             :locale="$i18n.locale"
                                             :time-from="timeFrom"
                                             :time-to="timeTo"
                                             :on-event-click="selectDate">
                                        <template #event="{ event }">
                                            <div
                                                class="vuecal__event-title"
                                                :style="{ backgroundColor: event.color, color: '#000' }"
                                                v-html="event.title"
                                            ></div>
                                            <div>
                                                <i class="ri-time-line"></i> {{ setTime(event.start) }}
                                            </div>
                                            <div>
                                                {{ event.content }}
                                            </div>
                                        </template>
                                    </vue-cal>
                                </b-col>
                            </b-row>
                        </div>
                    </ValidationObserver>
                </b-col>
            </b-row>
        </app-layout>
    </div>
</template>
<script>

import AppLayout from "@/layouts/AppLayout"
import Header from "@/layouts/AppLayout/Header"
import HeaderMobile from "@/layouts/AppLayout/HeaderMobile"

//Components
import {ValidationObserver, ValidationProvider} from "vee-validate"
import MultiSelectbox from "@/components/interactive-fields/MultiSelectbox"
import VueCal from 'vue-cal'
import 'vue-cal/dist/vuecal.css'
import '/src/locales/tr/vuecal.js'

//Services
import PcgcService from "@/services/PcgcService"

//Other
import moment from 'moment'
import qs from "qs";
//Pages




export default {
    components: {
        AppLayout,
        Header,
        HeaderMobile,

        ValidationProvider,
        ValidationObserver,
        MultiSelectbox,
        VueCal
    },
    metaInfo() {
        return {
            title: this.$t("pcgc"),
        };
    },
    data() {
        return {
            step: 1,
            approveData: {},
            approveOptions: [
                {
                    value: 'E',
                    text: this.$t("pcgc_approve"),
                },
                {
                    value: 'H',
                    text: this.$t("pcgc_decline"),
                }
            ],

            currentDateForm: moment(new Date()).format('DD-MM-YYYY'),

            studentData: {},

            placeOfResidenceOptions: [
                {
                    value: 'dormitory',
                    text: this.$t("pcgc_at_dormitory"),
                },
                {
                    value: 'with_family',
                    text: this.$t("pcgc_with_family"),
                },
                {
                    value: 'at_home_alone',
                    text: this.$t("pcgc_at_home_alone"),
                },
                {
                    value: 'with_relatives',
                    text: this.$t("pcgc_with_relatives"),
                },
                {
                    value: 'at_home_with_friends',
                    text: this.$t("pcgc_at_home_with_friends"),
                },
                {
                    value: 'other',
                    text: this.$t("other"),
                }
            ],

            applicationForm: {},

            yesNoOptions: [
                {
                    value: 'E',
                    text: this.$t("yes"),
                },
                {
                    value: 'H',
                    text: this.$t("no"),
                }
            ],

            parentsMaritialOptions: [
                {
                    value: 'married',
                    text: this.$t("married"),
                },
                {
                    value: 'divorced',
                    text: this.$t("pcgc_divorced"),
                },
                {
                    value: 'live_together',
                    text: this.$t("pcgc_live_together"),
                },
                {
                    value: 'married_to_others',
                    text: this.$t("pcgc_married_to_others"),
                },
                {
                    value: 'other',
                    text: this.$t("other"),
                }
            ],

            useMedicineOptions: [
                {
                    value: 'doctors_advise',
                    text: this.$t("pcgc_doctors_advice"),
                },
                {
                    value: 'myself',
                    text: this.$t("pcgc_myself"),
                },
                {
                    value: 'other',
                    text: this.$t("other"),
                }
            ],

            psychologistOptions: [],
            appointmentForm: {},

            timeFrom: 9 * 60,
            timeTo: 19 * 60,
            startDate: null,
            timetables: [],
            pdrm_app_id: null,
        }
    },

    mounted() {
        this.studentData = this.$store.getters['auth/getUser'] //#
        this.$store.dispatch("Pcgc/initPcgc")
        this.pdrm_app_id  = this.$store.getters['Pcgc/getId']
        if(this.pdrm_app_id){
            this.step = 3
        } else {
            this.step = 1
        }
    },
    watch: {
        'appointmentForm.psychologist': {
            handler(val) {
                this.getDates(val)
            }
        }
    },
    created() {
        this.getPsychologists()
    },
    methods: {
        getPsychologists() {
            PcgcService.getPsychologists().then(response => {
                response.data.data.forEach(item => {
                    this.psychologistOptions.push({
                        text: item.full_name,
                        value: item.psychologist_id,
                    })
                })
            }).catch(e => {
                this.showErrors(e, null)
            })
        },

        async saveApprove(){
            const isValid = await this.$refs.approveForm.validate()
            if (isValid) {
                this.step = 2
            }
        },

        async saveForm() {
            const isValid = await this.$refs.applicationForm.validate()
            if (isValid) {
                let formData = {
                    ...this.approveData,
                    ...this.applicationForm,
                    student_program_id: this.studentData.active_student_program.id
                }
                formData.share_with_family = formData.share_with_family == 'E' ? 1 : 0
                formData.share_with_university = formData.share_with_university == 'E' ? 1 : 0
                formData.share_with_instructor = formData.share_with_instructor == 'E' ? 1 : 0
                formData.mother_is_alive = formData.mother_is_alive == 'E' ? 1 : 0
                formData.father_is_alive = formData.father_is_alive == 'E' ? 1 : 0
                formData.has_siblings = formData.has_siblings == 'E' ? 1 : 0
                formData.has_external_psychological_support = formData.has_external_psychological_support == 'E' ? 1 : 0
                formData.has_suicide_attempt = formData.has_suicide_attempt == 'E' ? 1 : 0
                formData.has_self_harm_or_suicidal_thoughts = formData.has_self_harm_or_suicidal_thoughts == 'E' ? 1 : 0
                formData.has_diagnosed_physical_condition = formData.has_diagnosed_physical_condition == 'E' ? 1 : 0
                formData.has_psychological_treatment = formData.has_psychological_treatment == 'E' ? 1 : 0
                formData.has_medication = formData.has_medication == 'E' ? 1 : 0
                formData.has_previous_pdrm_interview = formData.has_previous_pdrm_interview == 'E' ? 1 : 0
                formData.emergency_contact_phone = formData.emergency_contact_phone ? formData.emergency_contact_phone.replace(/[^\d]/g, '') : null
                formData.mother_phone = formData.mother_phone ? formData.mother_phone.replace(/[^\d]/g, '') : null
                formData.father_phone = formData.father_phone ? formData.father_phone.replace(/[^\d]/g, '') : null
                formData.treatment_specialist_phone = formData.treatment_specialist_phone ? formData.treatment_specialist_phone.replace(/[^\d]/g, '') : null

                PcgcService.storeApplication(formData).then(response => {
                    this.$toast.success(this.$t("api."+response.data.message))
                    this.$store.dispatch("Pcgc/setPcgcId", response.data.data.id)
                    this.$store.dispatch("Pcgc/initPcgc")
                    this.pdrm_app_id  = this.$store.getters['Pcgc/getId']
                    this.step = 3
                }).catch(e => {
                    this.showErrors(e, this.$refs.applicationForm)
                })

            }
        },

        getDates(psychologist) {
            this.timetables = []
            const config = {
                params: {
                    filter: {
                        psychologist_id: psychologist,
                        status: 'available'
                    }
                },
                paramsSerializer: (params) => qs.stringify(params, {encode: false})
            }
            PcgcService.getAllAppointment(config).then(response => {
                response.data.data.forEach(item => {
                    this.timetables.push({
                        start: item.appointment_date + ' ' + item.appointment_time.substring(0,2)+':00',
                        end: item.appointment_date + ' ' + (parseInt(item.appointment_time.substring(0,2))+1)+':00',
                        title: item.psychologist_name+' '+item.psychologist_surname,
                        content: this.getLocaleText(item, 'status_name'),
                        id: item.id,
                        style: 'background-color: #87CEFA',
                    })
                })
            }).catch(e => {
                this.showErrors(e, null)
            })
        },

        setTime(time){
            return moment(time).format('HH:mm')
        },

        selectDate(event) {
            let dateR = moment(event.start).format('DD-MM-YYYY')
            let time = moment(event.start).format('HH')
            this.$swal.fire({
                title: this.$t('confirmation'),
                text: this.$t('pcgc_reserve_date_info',{date: dateR, time: time+':00', psychologist: event.title}),
                icon: 'info',
                showCancelButton: true,
                confirmButtonText: this.$t('yes'),
                cancelButtonText: this.$t('pcgc_no_view_others'),
            }).then((result) => {
                if (result.isConfirmed) {
                    let formData = {
                        status: 'requested',
                        pdrm_application_id: this.pdrm_app_id
                    }
                    PcgcService.updateAppointment(formData, event.id).then(response => {
                        this.$toast.success(this.$t('api.'+response.data.message))
                        this.$store.dispatch("Pcgc/removeData")
                        this.$router.push('/pcgc/my-applications')
                    }).catch(e => {
                        this.showErrors(e, null)
                    })

                }
            })
        }
    },
};
</script>

